export const environment = {
  legacyAppUrl: 'https://backend.secure.brandshelter.com',
  legacyFrontendURL: 'https://secure.brandshelter.com',
  brandMonitoringPortalURL: 'https://portal.bp.brandshelter.com',
  registerNewAccountUrl: 'https://www.brandshelter.com/sign-up',
  turnstileSiteKey: '0x4AAAAAACGOPmsM0Ji5RwCn'
};
